import { Scanner } from "@yudiel/react-qr-scanner";

export function BackupRestore() {
    const redirect = (url?: string) => {
        if (url) {
            window.location.replace(url);
        }
    };

    return (
        <Scanner
            onScan={(result) => redirect(result?.at(0)?.rawValue?.toString())}
        />
    );
}